/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect} from "react";
import {Link} from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import TableHeader from "../Common/TableHeader";
import Loader from "../Common/Loader";
import CompleteCall from "./CompleteCall";
import useStateCallback from "../../util/customHooks/useStateCallback";
import CallContext from "../../Context/CallContext";
import Pagination from "../Common/Pagination";
import CallLogsSearchForm from "../Common/CallLogs/CallLogsSearchForm";
import CallLogsTable from "../Common/CallLogs/CallLogsTable";
import SchoolContext from "../../Context/SchoolContext";

function ZegoVideoLogs() {

  const [modal, setModal] = useStateCallback(false);
  const {buzzVideoLogsList, buzzVideoSchool, buzzVideoCaller, buzzVideoMeta, buzzVideoPage, buzzVideoEndDate, buzzVideoStartDate, isRealTimeEnabled,
      isBuzzVideoSearching, loading2, setBuzzVideoPage, isFirstLoad, setIsRealTimeEnabled, setBuzzVideoSchool,
      setBuzzVideoCaller, setIsBuzzVideoSearching, setBuzzVideoEndDate, setBuzzVideoStartDate, getBuzzVideoLogsList, searchBuzzVideoLogs } = useContext(CallContext);
  const {schoolList} = useContext(SchoolContext);

  useEffect(() => {
    if (isRealTimeEnabled) {
      const intervalId = setInterval(() => {
        if (!isBuzzVideoSearching) {
          getBuzzVideoLogsList(buzzVideoPage);
        }
      }, 10000);
  
      return () => clearInterval(intervalId);
    }
  }, [buzzVideoPage, isBuzzVideoSearching, isRealTimeEnabled]);

  const completeCall = (e, item) => {
      setModal(false, () =>
        setModal(
          <CompleteCall
            callID={item.id}
            g={getBuzzVideoLogsList}
            page={buzzVideoPage}
            isOpen={true}
          />
        )
      );
  };

    const resetSearch = () => {
      setBuzzVideoCaller("");
      setBuzzVideoSchool("");
      setBuzzVideoStartDate("");
      setBuzzVideoEndDate("");
      setBuzzVideoPage(1);
      setIsBuzzVideoSearching(false);
      getBuzzVideoLogsList(1); 
  };

const exportToPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const columns = ["Date & Time", "Call Status", "Caller Details", "Callee Details", "Duration", "Station", "Call Cost"];
    const data = buzzVideoLogsList.map(item => [
      item.call_time,
      item.status,
      `${item.caller_name} (${item.caller_number})`,
      `${item.callee_name} (${item.callee_number})`,
      item.duration_format,
      `${item.station_name} (${item.school_name})`,
      `UGX. ${item.call_cost?.total_c}`,

    ]);

    pdf.autoTable({ head: [columns], body: data });
    pdf.save("buzz_video_call_logs.pdf");
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= buzzVideoMeta) {
      setBuzzVideoPage(newPage);
    }
  };

  useEffect(() => {
    if (buzzVideoCaller || buzzVideoSchool || buzzVideoStartDate || buzzVideoEndDate) {
      searchBuzzVideoLogs();
    } else {
      getBuzzVideoLogsList(buzzVideoPage);
    }
  }, [buzzVideoPage]);

  return (
    <>
      {modal}
     
      <div class="heading-layout1 mg-b-5">
        <TableHeader
          subtitle="List of all the buzz video calls sorted by the most recent"    
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" 
          data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={exportToPDF} ><i class="fas fa-file-export"></i>Export</Link>
            <Link class="dropdown-item" onClick={() => setIsRealTimeEnabled(!isRealTimeEnabled)} >{isRealTimeEnabled ?<i className="fa fa-toggle-on mr-1" style={{ color: "green" }}></i>:<i className="fa fa-toggle-off mr-1" style={{ color: "red" }}></i>}{isRealTimeEnabled ? "Real-Time Updates: ON" : "Real-Time Updates: OFF"}</Link>

          </div>
        </div>
      </div>

      <CallLogsSearchForm caller={buzzVideoCaller} school={buzzVideoSchool} setCaller={setBuzzVideoCaller} setSchool={setBuzzVideoSchool} startDate={buzzVideoStartDate}
         setStartDate={setBuzzVideoStartDate} endDate={buzzVideoEndDate} setEndDate={setBuzzVideoEndDate} searchCallLogs={searchBuzzVideoLogs}
         resetSearch={resetSearch} schoolList={schoolList} setPage={setBuzzVideoPage}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {isFirstLoad || loading2 ? (
          <Loader /> 
        ) : (
          <CallLogsTable logsList={buzzVideoLogsList} onCompleteCall={completeCall} logType="video"/>
        )}
      </div>

      <Pagination currentPage={buzzVideoPage} totalPages={buzzVideoMeta} onPageChange={handlePagination}/>

    </>
     
  
  );
}

export default ZegoVideoLogs;
